<template>
    <div>
        <b-row class="mb-3">
            <b-col><span class="h3">Diamond Pricing</span></b-col>
        </b-row>
        <b-card no-body>
            <b-tabs card pills small>
                <b-tab active>
                    <template #title>
                        <i class="fa-sharp fa-solid fa-octagon"></i> Round
                    </template>

                    <LoadingSpinner :busy="isLoading"></LoadingSpinner>

                    <template v-for="(value, index) in diamondData.round">

                        <b-card no-body :key="index" header-bg-variant="dark">
                            <template v-slot:header>
                                {{ index | ucFirst }}
                            </template>
                            <!--view table-->
                            <b-table small
                                     striped
                                     head-variant="light"
                                     class="text-center mb-0"
                                     :busy="isLoading"
                                     :items="value.items"
                                     :fields="value.fields">
                                <template v-slot:cell(shape)="data">
                                    {{ data.value | ucFirst }}
                                </template>
                                <template v-slot:cell(carats_min)="data">
                                    {{ data.value }}
                                </template>
                                <template v-slot:cell(carats_max)="data">
                                    {{ data.value }}
                                </template>
                                <template v-slot:cell(sort)="data">
                                    {{ data.value }}
                                </template>
                                <template v-slot:cell(edit)="data">
                                    <b-button class="ml-2" size="sm"
                                              :disabled="isLoading || isSaving"
                                              @click="startEdits(index, data.item.carats_max, data.item.shape)"
                                              variant="outline-info"><i class="fa-solid fa-edit"></i>
                                    </b-button>
                                </template>
                                <template v-slot:cell()="data">
                                    <div>{{ data.value[0] | currency }}</div>
                                    <small :class="data.value[1] > 0 ? '' : 'text-muted'">Lab Grown: {{ data.value[1] | currency }}</small>
                                </template>
                            </b-table>
                        </b-card>
                    </template>

                </b-tab>

                <b-tab no-body>
                    <template #title>
                        <i class="fa-sharp fa-solid fa-rectangle"></i> Fancy
                    </template>

                    <LoadingSpinner :busy="isLoading"></LoadingSpinner>

                    <template v-for="(value, index) in diamondData.fancy">

                        <b-card no-body :key="index" header-bg-variant="dark">
                            <template v-slot:header>
                                {{ index | ucFirst }}
                            </template>
                            <!--view table-->
                            <b-table small
                                     striped
                                     head-variant="light"
                                     class="text-center mb-0"
                                     :busy="isLoading"
                                     :items="value.items"
                                     :fields="value.fields">
                                <template v-slot:cell(shape)="data">
                                    {{ data.value | ucFirst }}
                                </template>
                                <template v-slot:cell(carats_min)="data">
                                    {{ data.value }}
                                </template>
                                <template v-slot:cell(carats_max)="data">
                                    {{ data.value }}
                                </template>
                                <template v-slot:cell(sort)="data">
                                    {{ data.value }}
                                </template>
                                <template v-slot:cell(edit)="data">
                                    <b-button class="ml-2" size="sm"
                                              :disabled="isLoading || isSaving"
                                              @click="startEdits(index, data.item.carats_max, data.item.shape)"
                                              variant="outline-info"><i class="fa-solid fa-edit"></i>
                                    </b-button>
                                </template>
                                <template v-slot:cell()="data">
                                    <div>{{ data.value[0] | currency }}</div>
                                    <small :class="data.value[1] > 0 ? '' : 'text-muted'">Lab Grown: {{ data.value[1] | currency }}</small>
                                </template>
                            </b-table>
                        </b-card>
                    </template>
                </b-tab>
            </b-tabs>
        </b-card>

        <b-modal id="modal-diamond-edit" title="Edit Diamonds" size="lg" centered
                 hide-header-close
                 no-close-on-backdrop
                 no-close-on-esc
                 ok-variant="success"
                 :ok-disabled="isSaving"
                 :cancel-disabled="isSaving"
                 @cancel="cancelEdits"
                 @ok="saveEdits">
            <template #modal-ok="{ ok }">
                <i v-if="!isSaving" class="ml-1 fa-regular fa-save fa-fw"></i>
                <i v-else class="fa-regular fa-spin fa-spinner fa-fw"></i>
                Save
            </template>

            <b-table
                small
                :items="itemsForEdit"
                :fields="['id', 'carats_min', 'carats_max', 'sort', 'shape', 'clarity', 'color', 'carat_price', 'lab_grown_carat_price',]">

                <template v-slot:cell(carats_min)="data">
                    <b-form-input type="number" step="0.01" v-model="data.item.carats_min"
                                  size="sm"
                                  :disabled="isSaving">
                    </b-form-input>
                </template>
                <template v-slot:cell(carats_max)="data">
                    <b-form-input type="number" step="0.01" v-model="data.item.carats_max"
                                  size="sm"
                                  :disabled="isSaving">
                    </b-form-input>
                </template>
                <template v-slot:cell(carat_price)="data">
                    <b-form-input type="number" step="0.1" number v-model="data.item.carat_price"
                                  size="sm"
                                  :disabled="isSaving">
                    </b-form-input>
                </template>
                <template v-slot:cell(lab_grown_carat_price)="data">
                    <b-form-input type="number" step="0.1" number v-model="data.item.lab_grown_carat_price"
                                  size="sm"
                                  :disabled="isSaving">
                    </b-form-input>
                </template>

            </b-table>
        </b-modal>

    </div>
</template>

<script>
import _ from 'lodash';
import LoadingSpinner from '@/components/LoadingSpinner';


export default {
    name: 'diamond-pricing-view',
    components: {
        LoadingSpinner,
    },
    data() {
        return {
            isLoading: false,
            isEditing: false,
            isSaving: false,
            diamond_definitions: [],
            diamond_definitions_fields: [
                'sort',
                'carats_min',
                'carats_max',
                'shape',
                'color',
                'clarity',
                'carat_price',
                'lab_grown_carat_price',
            ],
            diamond_definitions_cache: [],
            diamondDefinitionsMetalOptions: [
                {value: 'gold', text: 'Gold'},
                {value: 'silver', text: 'Silver'},
                {value: 'platinum', text: 'Platinum'},
            ],
            diamondDefinitionsPurityOptions: [
                {value: 'K', text: 'K'},
                {value: '%', text: '%'},
            ],
            diamondData: {
                round: [],
                fancy: [],
            },
            itemsForEdit: [],
        };
    },
    created() {
        this.getAllData();
    },
    watch: {},
    methods: {
        getAllData() {
            this.isLoading = true;
            this.$http.get('/diamond-definitions').then(response => {
                this.diamond_definitions = response.data.data;
                this.diamond_definitions_cache = _.cloneDeep(this.diamond_definitions);
                this.parseData();
                this.isLoading = false;
            });
        },
        parseData() {
            let roundGroupedByClarity = {};
            let roundGroupedByClarityByCarat = {};

            let fancyGroupedByClarity = {};
            let fancyGroupedByClarityByCarat = {};

            // Set Round
            _.forEach(_.filter(this.diamond_definitions, ['shape', 'round']), function (value) {
                // Add clarity groupings
                if (!roundGroupedByClarity[value.clarity]) {
                    roundGroupedByClarity[value.clarity] = {};
                }

                // Group by max carat size
                if (!roundGroupedByClarity[value.clarity][value.carats_max]) {
                    roundGroupedByClarity[value.clarity][value.carats_max] = [];
                }
                roundGroupedByClarity[value.clarity][value.carats_max].push(value);
                //roundGroupedByClarity[value.clarity][value.carats_max][value.color] = value;
            });

            // Build display rows
            _.forEach(roundGroupedByClarity, function (value, index) {
                roundGroupedByClarityByCarat[index] = {};
                roundGroupedByClarityByCarat[index].items = [];
                roundGroupedByClarityByCarat[index].fields = [];
                let currentClarity = index;

                _.forEach(roundGroupedByClarity[index], function (value) {
                    let baseObject = _.first(value);

                    // Start items data
                    let item = {
                        shape: baseObject.shape,
                        carats_min: baseObject.carats_min,
                        carats_max: baseObject.carats_max,
                        sort: baseObject.sort,
                    };

                    // Start fields data
                    let fields = [
                        'shape',
                        'carats_min',
                        'carats_max',
                        'sort',
                    ];

                    // Build variable items and fields
                    _.forEach(value, function (itemValue) {
                        item[itemValue.color] = [itemValue.carat_price, itemValue.lab_grown_carat_price];
                        fields.push(itemValue.color);
                    });

                    fields.push('edit');

                    roundGroupedByClarityByCarat[currentClarity].items.push(item);
                    roundGroupedByClarityByCarat[currentClarity].fields = fields;
                });

            });

            this.$set(this.diamondData, 'round', roundGroupedByClarityByCarat);


            // Set Fancy
            _.forEach(_.filter(this.diamond_definitions, ['shape', 'fancy']), function (value) {
                // Add clarity groupings
                if (!fancyGroupedByClarity[value.clarity]) {
                    fancyGroupedByClarity[value.clarity] = {};
                }

                // Group by max carat size
                if (!fancyGroupedByClarity[value.clarity][value.carats_max]) {
                    fancyGroupedByClarity[value.clarity][value.carats_max] = [];
                }
                fancyGroupedByClarity[value.clarity][value.carats_max].push(value);
                //fancyGroupedByClarity[value.clarity][value.carats_max][value.color] = value;
            });

            // Build display rows
            _.forEach(fancyGroupedByClarity, function (value, index) {
                fancyGroupedByClarityByCarat[index] = {};
                fancyGroupedByClarityByCarat[index].items = [];
                fancyGroupedByClarityByCarat[index].fields = [];
                let currentClarity = index;

                _.forEach(fancyGroupedByClarity[index], function (value) {
                    let baseObject = _.first(value);

                    // Start items data
                    let item = {
                        shape: baseObject.shape,
                        carats_min: baseObject.carats_min,
                        carats_max: baseObject.carats_max,
                        sort: baseObject.sort,
                    };

                    // Start fields data
                    let fields = [
                        'shape',
                        'carats_min',
                        'carats_max',
                        'sort',
                    ];

                    // Build variable items and fields
                    _.forEach(value, function (itemValue) {
                        item[itemValue.color] = [itemValue.carat_price, itemValue.lab_grown_carat_price];
                        fields.push(itemValue.color);
                    });

                    fields.push('edit');

                    fancyGroupedByClarityByCarat[currentClarity].items.push(item);
                    fancyGroupedByClarityByCarat[currentClarity].fields = fields;
                });

            });

            this.$set(this.diamondData, 'fancy', fancyGroupedByClarityByCarat);
        },

        startEdits(clarity, carats_max, shape) {
            this.itemsForEdit = _.filter(this.diamond_definitions, {
                'clarity': clarity,
                'carats_max': carats_max,
                'shape': shape
            });
            this.isEditing = true;

            this.$bvModal.show('modal-diamond-edit');
        },

        cancelEdits() {
            this.itemsForEdit = [];
            this.diamond_definitions = _.cloneDeep(this.diamond_definitions_cache);
            this.isEditing = false;
            this.$bvModal.hide('modal-diamond-edit');
        },

        saveEdits(bvModalEvent) {
            this.isSaving = true;
            bvModalEvent.preventDefault();
            this.$http.put('/diamond-definitions/updateAll', {diamond_definitions: this.itemsForEdit})
                .then(response => {
                    this.diamond_definitions = response.data.data;
                    this.diamond_definitions_cache = _.cloneDeep(this.diamond_definitions);

                    this.$nextTick(() => {
                        this.isSaving = false;
                        this.isEditing = false;
                        this.itemsForEdit = [];
                        this.parseData();
                        this.$bvModal.hide('modal-diamond-edit');
                    });
                });
        },

    },
};
</script>

<style scoped>

</style>
